module.exports = __webpack_public_path__ + "img/douyin.0b188f10.png";